import script from "./AgendamentosRepository.vue?vue&type=script&lang=js"
export * from "./AgendamentosRepository.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__